import WmsMobileLayout from "../wmsMobileLayout";
import PageTitle from "../../../components/WMS/Mobile/PageTitle";
import {FormattedMessage} from "react-intl";
import ToBeSortedTrolleys from "./components/ToBeSortedTrolleys";

function Sorting() {
    return (
        <WmsMobileLayout className="wms-test-component">
            <WmsMobileLayout.LeftHeader>
            </WmsMobileLayout.LeftHeader>
            <WmsMobileLayout.RightHeader>
            </WmsMobileLayout.RightHeader>

            <WmsMobileLayout.Content>
                <PageTitle title={<FormattedMessage id={"wms.sorting.mainTitle"}/>} subtitle={<FormattedMessage id={"wms.sorting.mainSubtitle"}/>} />
                <ToBeSortedTrolleys/>
            </WmsMobileLayout.Content>
        </WmsMobileLayout>
    );
}

export default Sorting;
